import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/header.css';
import logo from '../assets/logo-comece.svg';

// Telas onde não faz sentido "voltar" (entrada do sistema)
const SEM_VOLTAR = ['/', '/home', '/login'];

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const mostrarVoltar = !SEM_VOLTAR.includes((location.pathname || '').toLowerCase());

  // Volta para a tela anterior (checklist -> painel da Contabilidade, etc.).
  // Sem histórico (aba aberta direto no link) cai no painel inicial.
  const voltar = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/home');
  };

  return (
    <header className="custom-header text-center">
      {mostrarVoltar && (
        <button type="button" className="header-voltar" onClick={voltar} title="Voltar para a tela anterior">
          <i className="fas fa-arrow-left me-2"></i>Voltar
        </button>
      )}
      <img
        src={logo}
        alt="Logo"
        className="img-fluid"
        style={{ width: '180px', height: 'auto' }}
      />
      <p className="header-text">Comece.dev</p>
    </header>
  );
};

export default Header;
